import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/theme-light.css"; // v2.7.43 · light-mode override layer
import "@/styles/a11y.css";        // v2.7.45+E9 · ADA / WCAG 2.1 AA layer
import "@/i18n";                   // v2.7.45+E9 · initialise i18next BEFORE mount
import App from "@/App";
import { bootThemeBeforePaint } from "@/contexts/ThemeContext";

// v2.7.43 · Apply the user's stored theme to <html> BEFORE React mounts
// so the first paint already has the correct background — eliminates the
// brief dark flash a light-mode user would otherwise see on every reload.
bootThemeBeforePaint();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
